// --------------------------------------------------------------------------
// floorplanZoom.js
// --------------------------------------------------------------------------
// Uses magnific popup to open floorplan in lightbox
// --------------------------------------------------------------------------

EC.floorplanZoom = function () {

    'use strict';

    function init () {
        $('.js-floorplan-zoom').magnificPopup({
            type: 'image',
            mainClass: 'b-venue-floorplan__popup'
        });
    }

    return {
        init: init
    };

}();